import { Component, AfterViewInit, ComponentFactoryResolver, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { AppService } from '@api';
import { MensajeService } from '@mensaje/Mensaje.Service';
import { TranslateService } from '@ngx-translate/core';
import { SistemaService } from '@servicios/Sistema.Service';
import { AlineacionImagenEnum } from "@componentes/Enums.enum";
import { MatTabGroup, _MatTabGroupBase } from '@angular/material/tabs';
import { ReporteEvaluacionDetalleGeneralComponent } from './seccion/evaluaciondetalle_general.component';
import { ReporteEvaluacionDetalleAlumnoComponent } from './seccion/evaluaciondetalle_alumno.component';
import { ReporteEvaluacionDetallePadreComponent } from './seccion/evaluaciondetalle_padre.component';
import { RespuestaEstatusEnum } from '@enumeraciones/Enumeraciones.enum';
import { AlertaEnum } from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import { ReporteEvaluacionDetalleTallerAlumnoComponent } from './seccion/evaluaciondetalle_talleralumno.component';
import { ReporteEvaluacionDetalleTallerPadreComponent } from './seccion/evaluaciondetalle_tallerpadre.component';



@Component({
    selector: 'reporteevaluaciondetalle',
    templateUrl: './evaluaciondetalle.component.html',
    styleUrls: ['./evaluaciondetalle.component.scss']
})

export class ReporteEvaluacionDetalleComponent implements AfterViewInit{
    consulta!: boolean;
    @ViewChild('tab') private tab!: _MatTabGroupBase;
    @Input() entidad!: any;
    @Input() periodoevaluacion!: any;
    @Output() output = new EventEmitter();

    @ViewChild('general') private general!: ReporteEvaluacionDetalleGeneralComponent;
    @ViewChild('alumno') private alumno!: ReporteEvaluacionDetalleAlumnoComponent;
    @ViewChild('padre') private padre!: ReporteEvaluacionDetallePadreComponent;
    @ViewChild('alumnotaller') private alumnotaller!: ReporteEvaluacionDetalleTallerAlumnoComponent;
    @ViewChild('padretaller') private padretaller!: ReporteEvaluacionDetalleTallerPadreComponent;

    handleTabClick:any
    selectedTabIndex = 0;

    numero: number = 0;
    listapuesto: any[] = [];

    public AlineacionImagenEnum = AlineacionImagenEnum;
    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){

    }

    ngAfterViewInit(){
      if(this.entidad.otropuesto){
        this.buscarpuesto();
      }
    }

    Generarpdf(){
        let general = {};
        switch (this.selectedTabIndex) {
            case 0:
                if(this.general.general.otropuesto){
                  if(this.general.puesto){
                    general = {"general": this.general.general, "periodo":this.general.periodo, "visualizacion": this.general.tipovisualizacion, "seleccionreporte": 1, "puestolocal": this.general.puestolocal};
                  }else{
                    this.mensajeService.Alerta(AlertaEnum.Warning, "Para descargar el reporte es necesario seleccionar un Puesto");
                  }
                }else{
                  general = {"general": this.general.general, "periodo":this.general.periodo, "visualizacion": this.general.tipovisualizacion, "seleccionreporte": 1, "puestolocal": this.general.puestolocal};
                }
                break;
            case 1:
                if(this.alumno.general.otropuesto){
                  if(this.alumno.puesto){
                    general = {"alumno": this.alumno.general, "periodo":this.alumno.periodo, "visualizacion": this.alumno.visual, "seleccionreporte": 2, "grupo": this.alumno.grupo, "materia": this.alumno.materia, "puestolocal": this.alumno.puestolocal};
                  }else{
                    this.mensajeService.Alerta(AlertaEnum.Warning, "Para descargar el reporte es necesario seleccionar un Puesto");
                  }
                }else{
                  general = {"alumno": this.alumno.general, "periodo":this.alumno.periodo, "visualizacion": this.alumno.visual, "seleccionreporte": 2, "grupo": this.alumno.grupo, "materia": this.alumno.materia, "puestolocal": this.alumno.puestolocal};
                }
                break;
            case 2:
                if(this.padre.general.otropuesto){
                  if(this.padre.puesto){
                    general = {"padre": this.padre.general, "periodo":this.padre.periodo, "visualizacion": this.padre.visual, "seleccionreporte": 3, "grupo": this.padre.grupo, "materia": this.padre.materia, "puestolocal": this.padre.puestolocal};
                  }else{
                    this.mensajeService.Alerta(AlertaEnum.Warning, "Para descargar el reporte es necesario seleccionar un Puesto");
                  }
                }else{
                  general = {"padre": this.padre.general, "periodo":this.padre.periodo, "visualizacion": this.padre.visual, "seleccionreporte": 3, "grupo": this.padre.grupo, "materia": this.padre.materia, "puestolocal": this.padre.puestolocal};
                }
                break;
            case 3:
              if(this.alumnotaller.general.otropuesto){
                if(this.alumnotaller.puesto){
                  general = {"alumno": this.alumnotaller.general, "periodo":this.alumnotaller.periodo, "visualizacion": this.alumnotaller.visual, "seleccionreporte": 4, "grupo": this.alumnotaller.grupo, "taller": this.alumnotaller.taller, "puestolocal": this.alumnotaller.puestolocal};
                }else{
                  this.mensajeService.Alerta(AlertaEnum.Warning, "Para descargar el reporte es necesario seleccionar un Puesto");
                }
              }else{
                general = {"alumno": this.alumnotaller.general, "periodo":this.alumnotaller.periodo, "visualizacion": this.alumnotaller.visual, "seleccionreporte": 4, "grupo": this.alumnotaller.grupo, "taller": this.alumnotaller.taller, "puestolocal": this.alumnotaller.puestolocal};
              }
              break;
            case 4:
              if(this.padretaller.general.otropuesto){
                if(this.padretaller.puesto){
                  general = {"padre": this.padretaller.general, "periodo":this.padretaller.periodo, "visualizacion": this.padretaller.visual, "seleccionreporte": 5, "grupo": this.padretaller.grupo, "taller": this.padretaller.taller, "puestolocal": this.padretaller.puestolocal};
                }else{
                  this.mensajeService.Alerta(AlertaEnum.Warning, "Para descargar el reporte es necesario seleccionar un Puesto");
                }
              }else{
                general = {"padre": this.padretaller.general, "periodo":this.padretaller.periodo, "visualizacion": this.padretaller.visual, "seleccionreporte": 5, "grupo": this.padretaller.grupo, "taller": this.padretaller.taller, "puestolocal": this.padretaller.puestolocal};
              }
              break;
        }
        if(Object.keys(general).length === 0){
          return;
        }
        this.appService.PostGetFile("reporte/evaluacion/generarpdf", general).then(res=> {
            if(res.status == RespuestaEstatusEnum.Success){

            }
        })
    }

    buscarpuesto(){
      this.appService.Post("reporte/evaluacion/obtenerpuesto",{"data":this.entidad, "periodoevaluacionid":this.periodoevaluacion}).then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.listapuesto = res.data;
        }
      })
    }

    Salir(){
        this.output.next();
    }
}
